module.exports = __webpack_public_path__ + "img/google.faa8fdef.jpg";